import { invokeApig } from '../libs/awsLib';

class featureFlagApi {
  static async getFeatureFlags(userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: `/entities/rules/feature-flags`,
        method: 'GET',
      },
      userToken
    );
  }

  static async updateFeatureFlag(featureFlag, feature, userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: '/entities/rules/feature-flags/update/' + featureFlag,
        method: 'PUT',
        body: feature,
      },
      userToken
    );
  }

  static async addFeatureFlag(feature, userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: '/entities/rules/feature-flags/add/',
        method: 'POST',
        body: feature,
      },
      userToken
    );
  }

  static async deleteFeatureFlag(featureFlag, userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: '/entities/rules/feature-flags/delete/' + featureFlag,
        method: 'DELETE',
      },
      userToken
    );
  }

  static async enableFeatureFlag(featureFlag, userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: '/entities/rules/feature-flags/enable',
        body: { feature_flag_id: featureFlag },
        method: 'PUT',
      },
      userToken
    );
  }

  static async disableFeatureFlag(featureFlag, userToken) {
    return invokeApig(
      {
        service: 'RULES',
        path: '/entities/rules/feature-flags/disable',
        body: { feature_flag_id: featureFlag },
        method: 'PUT',
      },
      userToken
    );
  }
}
export default featureFlagApi;
